import React, { useState } from 'react';
import { db } from '../../config/firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import './FeedbackForm.css';

const FeedbackForm = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [feedbackType, setFeedbackType] = useState('');
  const [feedback, setFeedback] = useState('');
  const [userName, setUserName] = useState('');
  const [showStatusOverlay, setShowStatusOverlay] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessOverlay, setShowSuccessOverlay] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!feedback.trim() || !feedbackType || !userName.trim()) {
      setSubmitStatus(
        !feedbackType ? 'Please select a feedback type' : 
        !userName.trim() ? 'Please enter your name' :
        'Please tell us about your experience'
      );
      setShowStatusOverlay(true);
      return;
    }

    setIsSubmitting(true);
    
    try {
      const feedbackData = {
        type: feedbackType,
        message: feedback.trim(),
        userName: userName.trim(),
        timestamp: serverTimestamp(),
        status: 'new',
        metadata: {
          userAgent: navigator.userAgent,
          platform: navigator.platform,
          language: navigator.language,
          timestamp: new Date().toISOString()
        }
      };

      const feedbackRef = collection(db, 'feedback');
      await addDoc(feedbackRef, feedbackData);
      
      setShowSuccessOverlay(true);
      setFeedback('');
      setFeedbackType('');
      setUserName('');
      
      setTimeout(() => {
        setIsOpen(false);
        setShowSuccessOverlay(false);
      }, 3000);

    } catch (error) {
      console.error('Feedback submission error:', error);
      setSubmitStatus('Unable to submit feedback. Please try again later.');
      setShowStatusOverlay(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const StatusOverlay = ({ message, type, onClose }) => (
    <div className="status-overlay">
      <div className={`status-message ${type}`}>
        {message}
        <button className="close-button" onClick={onClose}>×</button>
      </div>
    </div>
  );

  const SuccessOverlay = () => (
    <div className="success-overlay">
      <div className="success-content">
        <div className="success-icon">✓</div>
        <h3>Thank You!</h3>
        <p>Your feedback has been submitted successfully</p>
      </div>
    </div>
  );

  if (!isOpen) {
    return (
      <button 
        className="feedback-button" 
        onClick={() => setIsOpen(true)}
        aria-label="Open feedback form"
      >
        Feedback
      </button>
    );
  }

  return (
    <>
      <div className="feedback-overlay">
        <div className="feedback-modal">
          <button 
            className="close-modal" 
            onClick={() => setIsOpen(false)}
            aria-label="Close feedback form"
          >
            ×
          </button>
          
          <h2>Share Your Feedback</h2>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="userName">Your Name:</label>
              <input
                type="text"
                id="userName"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                placeholder="Enter your name"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="feedbackType">Type of Feedback:</label>
              <select
                id="feedbackType"
                value={feedbackType}
                onChange={(e) => setFeedbackType(e.target.value)}
                required
              >
                <option value="">Select type</option>
                <option value="bug">Report a Bug</option>
                <option value="feature">Feature Request</option>
                <option value="general">General Feedback</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="feedback">Your Feedback:</label>
              <textarea
                id="feedback"
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                placeholder="Tell us about your experience..."
                required
              />
            </div>

            <button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
            </button>
          </form>
        </div>
      </div>

      {showSuccessOverlay && <SuccessOverlay />}

      {showStatusOverlay && !showSuccessOverlay && (
        <StatusOverlay 
          message={submitStatus}
          type="error"
          onClose={() => setShowStatusOverlay(false)}
        />
      )}
    </>
  );
};

export default FeedbackForm; 